import { useEffect, useState } from 'react';

// A "tank level" gauge that fills with water as the visitor scrolls the page.
export default function ScrollGauge() {
  const [level, setLevel] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      setLevel(max > 0 ? Math.min(100, Math.max(0, (window.scrollY / max) * 100)) : 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  return (
    <>
      {/* thin bar on small screens */}
      <div className="fixed inset-x-0 top-0 z-[60] h-1 xl:hidden" aria-hidden="true">
        <div className="h-full bg-brand-600 transition-[width] duration-150" style={{ width: `${level}%` }} />
      </div>

      {/* tank gauge on large screens */}
      <div
        className="fixed bottom-8 right-6 z-40 hidden flex-col items-center gap-2 xl:flex"
        aria-hidden="true"
      >
        <span className="font-display text-[0.65rem] font-semibold tracking-widest text-gray-400 [writing-mode:vertical-rl]">
          TANK LEVEL
        </span>
        <div className="relative h-40 w-4 overflow-hidden rounded-full bg-gray-200/80 ring-1 ring-black/5 backdrop-blur">
          <div
            className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-brand-700 to-brand-500 transition-[height] duration-150"
            style={{ height: `${level}%` }}
          />
          {[25, 50, 75].map((t) => (
            <span key={t} className="absolute left-0 h-px w-1.5 bg-black/30" style={{ bottom: `${t}%` }} />
          ))}
        </div>
        <span className="font-display text-xs font-bold tabular-nums text-brand-600">
          {Math.round(level)}%
        </span>
      </div>
    </>
  );
}
